// src/components/Lightbox.ts
// Image zoom modal for meal plans

export class Lightbox {
  private el: HTMLElement;
  private img: HTMLImageElement;

  constructor() {
    this.el = document.createElement('div');
    this.el.className = 'lightbox';
    this.el.innerHTML = `
      <img class="lightbox-img" src="" alt="Zoomed preview" />
    `;
    this.img = this.el.querySelector('.lightbox-img')!;

    this.el.addEventListener('click', () => this.close());
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.el.classList.contains('open')) {
        this.close();
      }
    });

    document.body.appendChild(this.el);
  }

  public open(src: string) {
    this.img.src = src;
    this.el.classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  public close() {
    this.el.classList.remove('open');
    document.body.style.overflow = '';
  }
}

export const lightbox = new Lightbox();
